import { PERSONA_TYPE_TO_BASE_PATH_MAPPING } from '../components/hooks/useAuth';
import { RedirectToMfaConfig } from '../components/modals/v2/RedirectToMfa';
import { Modal } from '../components/modals/v2/helpers/v2.modal.helpers';
import { MfaType } from '../console/_statics/mfa.statics';
import { PERSONA_TYPES, type Persona } from '../console/_statics/persona.statics';

interface UserDataMfaProps {
  mfaType: MfaType;
  account: {
    accountType: Persona;
    enforceMfa: boolean;
  };
}

const MANAGE_PROFILE_VIEW_URL = 'manage/me' as const;
// Profile tabs are selected via TabSubrouter path segments (see Profile.tsx),
// so the MFA tab lives at `manage/me/mfa`, not the old `?tab=mfa` query form.
const MANAGE_MFA_VIEW_URL = 'manage/me/mfa' as const;

export function getProfileMfaUrl(accountType: Persona) {
  const personaUrl = PERSONA_TYPE_TO_BASE_PATH_MAPPING[accountType];

  // The Agency persona still renders the legacy AgentProfileTab, whose v1 Tabs
  // select the active tab via the `?tab=` query param — not TabSubrouter path
  // segments. Every other persona renders the path-segment Profile.tsx, where
  // the MFA tab lives at `manage/me/mfa`. Sending an agency user to the path
  // form lands on the default Profile tab and never opens MFA setup.
  if (accountType === PERSONA_TYPES.AGENCY) {
    return `/${personaUrl}/${MANAGE_PROFILE_VIEW_URL}?tab=mfa`;
  }

  return `/${personaUrl}/${MANAGE_MFA_VIEW_URL}`;
}

export function isMfaEnforced(userData: UserDataMfaProps) {
  if (!userData) {
    return false;
  }

  const ssoLogin = sessionStorage.getItem('ssoLogin');
  if (ssoLogin === 'true') {
    return false;
  }

  const { mfaType } = userData;
  const enforceMfa = userData.account?.enforceMfa;

  return enforceMfa && mfaType === MfaType.NONE;
}

export function checkIfMfaEnforced(userData: UserDataMfaProps) {
  // check is so you can go to the other tab to change contact number
  if (window.location.href.includes(MANAGE_PROFILE_VIEW_URL)) {
    return;
  }

  if (isMfaEnforced(userData)) {
    const profileMfaUrl = getProfileMfaUrl(userData.account?.accountType);

    Modal.show(RedirectToMfaConfig, {
      data: { profileMfaUrl },
    });
  }
}
